module.exports = __webpack_public_path__ + "media/images/cofinancing_entities/centro2020-2dd9b027f30b61ee4c07cc99f9afb41c.png";